var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006664",
    d: "M372.7 186h465.5c25.7 0 46.5 20.8 46.5 46.5S863.9 279 838.2 279H372.7c-25.7 0-46.5-20.8-46.5-46.5S347 186 372.7 186zM205.2 837.6c-36 0-65.2-29.2-65.2-65.2s29.2-65.2 65.2-65.2 65.2 29.2 65.2 65.2-29.2 65.2-65.2 65.2z m0-260.6c-36 0-65.2-29.2-65.2-65.2s29.2-65.2 65.2-65.2 65.2 29.2 65.2 65.2-29.2 65.2-65.2 65.2z m0-260.7c-36 0-65.2-29.2-65.2-65.2s29.2-65.1 65.2-65.1 65.2 29.2 65.2 65.2-29.2 65.1-65.2 65.1z m633 242.1H372.7c-25.7 0-46.5-20.9-46.5-46.5 0-25.7 20.9-46.5 46.5-46.5h465.5c25.7 0 46.5 20.9 46.5 46.5s-20.9 46.5-46.5 46.5z m-465.5-46.6h465.5-465.5z m465.5 325.8H372.7c-25.7 0-46.5-20.9-46.5-46.5s20.9-46.5 46.5-46.5h465.5c25.7 0 46.5 20.9 46.5 46.5s-20.9 46.5-46.5 46.5z m-465.5-46.5h465.5-465.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.469b88b1a37575e3f23b6a0c72565322.svg";
export { ForwardRef as ReactComponent };